import { AvisoDesatualizado } from '@/components/status/aviso-desatualizado';
import { CabecalhoStatus } from '@/components/status/cabecalho-status';
import { EsqueletoStatus } from '@/components/status/esqueleto-status';
import { EstadoGlobal } from '@/components/status/estado-global';
import { HistoricoIncidentes } from '@/components/status/historico-incidentes';
import { IncidenteAtivo } from '@/components/status/incidente-ativo';
import { ListaServicos } from '@/components/status/lista-servicos';
import { ManutencoesProgramadas } from '@/components/status/manutencoes-programadas';
import { RodapeStatus } from '@/components/status/rodape-status';
import { TelaErro } from '@/components/status/tela-erro';
import { derivarEstadoGeral, montarResumoGeral } from '@/helpers/status.helpers';
import { useStatus } from '@/hooks/use-status';

export const App = () => {
  const { fase, status, frescor, idadeSegundos, erro, atualizando, atualizarAgora } = useStatus();

  return (
    <div className="min-h-screen bg-muted px-5 pb-16">
      <CabecalhoStatus />

      <main className="mx-auto flex w-full max-w-[820px] flex-col gap-3.5">
        {fase === 'carregando' && <EsqueletoStatus />}

        {fase === 'erro' && (
          <TelaErro motivo={erro} atualizando={atualizando} aoAtualizar={atualizarAgora} />
        )}

        {fase === 'pronto' && status && (
          <>
            <AvisoDesatualizado
              frescor={frescor}
              idadeSegundos={idadeSegundos}
              atualizando={atualizando}
              aoAtualizar={atualizarAgora}
            />

            <EstadoGlobal
              estado={derivarEstadoGeral(status, frescor)}
              resumo={montarResumoGeral(status, frescor)}
            />

            {status.incidentes_ativos.map((incidente) => (
              <IncidenteAtivo key={incidente.id} incidente={incidente} />
            ))}

            <ListaServicos
              servicos={status.servicos}
              janelaDias={status.janela_dias}
              frescor={frescor}
            />

            <ManutencoesProgramadas manutencoes={status.manutencoes} />

            <HistoricoIncidentes historico={status.historico} janelaDias={status.janela_dias} />

            <RodapeStatus idadeSegundos={idadeSegundos} suporte={status.suporte} />
          </>
        )}
      </main>
    </div>
  );
};
